/*
 * Phone numbers, shown one way and dialled another.
 *
 * What a person typed is stored as they typed it. These helpers only decide how
 * it is DISPLAYED and where a tap on Call or WhatsApp goes; nothing here is
 * written back. Puerto Rico is +1, so ten digits (or eleven starting with 1)
 * is a North American number and gets (787) 555-0123; anything else — a
 * foreign number, an extension — is shown exactly as typed rather than guessed
 * at.
 */

/** Digits only, with a leading + kept, as a `tel:` target wants. */
export function phoneHref(raw: string): string {
  return `tel:${raw.replace(/[^\d+]/g, '')}`
}

/** wa.me wants digits and the country code, no plus. */
export function whatsappHref(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  return `https://wa.me/${digits.length === 10 ? `1${digits}` : digits}`
}

/** "(787) 555-0123" for a North American number; the trimmed original otherwise. */
export function formatPhone(raw: string): string {
  const trimmed = raw.trim()
  const digits = trimmed.replace(/\D/g, '')
  const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits
  const plain = /^\+?1?[\s().-]*\d[\d\s().-]*$/.test(trimmed) || /^\d+$/.test(trimmed)
  if (national.length !== 10 || !plain) return trimmed
  return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`
}
